var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('layout-report-with-banner', {
    attrs: {
      "isProgressDone": true,
      "showFooter": true,
      "showLoginButton": _vm.showLoginButton
    },
    scopedSlots: _vm._u([{
      key: "banner",
      fn: function fn() {
        return [_c('v-img', {
          staticClass: "hidden-xs-only",
          attrs: {
            "src": _vm.headerImage,
            "height": "450"
          }
        }, [_c('v-overlay', {
          attrs: {
            "value": "true",
            "absolute": ""
          }
        }, [_c('v-container', {
          staticClass: "mx-auto"
        }, [_c('v-row', [_c('v-col', {
          staticClass: "ml-4"
        }, [_c('h1', {
          staticClass: "text-md-h2 text-sm-h3 text-h4 font-weight-medium mt-sm-8 mt-md-0",
          domProps: {
            "innerHTML": _vm._s(_vm.$t(_vm.slogan))
          }
        })])], 1), _c('v-row', {
          staticClass: "mt-8"
        }, [_c('v-col', {
          attrs: {
            "xl": "4",
            "lg": "5",
            "md": "6",
            "xs": "10",
            "sm": "8",
            "cols": "10"
          }
        }, [_c('v-btn', {
          staticClass: "ml-4",
          attrs: {
            "color": _vm.color,
            "id": "start",
            "elevation": "0",
            "block": "",
            "dark": "",
            "x-large": "",
            "data-test-report-start-desktop-only": ""
          },
          on: {
            "click": _vm.start
          }
        }, [_vm._v(" " + _vm._s(_vm.$t(_vm.headerButtonText)) + " ")])], 1)], 1), _c('div', {
          staticClass: "text-caption mb-4 mt-4 mx-4"
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-shield-check")]), _vm._v(" " + _vm._s(_vm.$t("report.trustBanner.privacy")) + " "), _c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-lock")]), _vm._v(" " + _vm._s(_vm.$t("report.trustBanner.encryption")) + " "), _c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-check-decagram")]), _vm._v(" " + _vm._s(_vm.$t("report.trustBanner.datacenter")) + " ")], 1)], 1)], 1)], 1)];
      },
      proxy: true
    }, {
      key: "content",
      fn: function fn() {
        return [!_vm.isMobile ? _c('v-row', {
          staticClass: "mt-md-4",
          attrs: {
            "align": "center",
            "justify": "center"
          }
        }, [_c('v-col', {
          attrs: {
            "md": "6",
            "cols": "12"
          }
        }, [_c('v-card', {
          attrs: {
            "flat": ""
          }
        }, [_c('v-card-title', {
          staticClass: "text-h4 font-weight-black",
          style: "color:".concat(_vm.partnerColorDarkmode, "; word-break: break-word")
        }, [_vm._v(" " + _vm._s(_vm.$t(_vm.title)) + " ")]), _c('v-card-text', {
          staticClass: "text-body-1 pt-4"
        }, _vm._l(_vm.items, function (item, i) {
          return _c('v-row', {
            key: i
          }, [_c('v-col', {
            attrs: {
              "cols": "1"
            }
          }, [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _c('v-col', {
            staticClass: "pl-6 pl-sm-2",
            attrs: {
              "cols": "11"
            }
          }, [_c('p', [_vm._v(_vm._s(_vm.$t(item.text)))])])], 1);
        }), 1), _c('v-card-actions', {
          staticClass: "px-4 py-4"
        }, [_c('login-register-button', {
          attrs: {
            "showRegisterButton": false,
            "htmlClass": "mr-2"
          }
        }), _c('v-btn', {
          attrs: {
            "color": _vm.color,
            "id": "start",
            "elevation": "0",
            "dark": "",
            "large": "",
            "data-test-report-start": ""
          },
          on: {
            "click": _vm.start
          }
        }, [_vm._v(" " + _vm._s(_vm.$t(_vm.buttonText)) + " ")])], 1)], 1)], 1), _c('v-col', {
          attrs: {
            "md": "6",
            "cols": "12"
          }
        }, [_c('v-card', {
          attrs: {
            "flat": ""
          }
        }, [_vm.videoSrc ? _c('v-card-subtitle', {
          staticClass: "d-flex d-sm-none"
        }, [_vm._v("Lernen Sie uns kennen")]) : _vm._e(), _c('v-card-text', {
          staticClass: "text-center"
        }, [_vm.videoSrc ? _c('video', {
          staticStyle: {
            "max-width": "100%",
            "max-height": "100%"
          },
          attrs: {
            "controls": ""
          }
        }, [_c('source', {
          attrs: {
            "src": _vm.videoSrc,
            "type": "video/mp4"
          }
        })]) : _c('v-img', {
          staticClass: "ma-8 hidden-sm-and-down",
          attrs: {
            "src": _vm.imageSrc
          }
        })], 1)], 1)], 1)], 1) : _c('v-card', {
          attrs: {
            "flat": true
          }
        }, [_c('v-row', {
          attrs: {
            "align": "stretch"
          }
        }, [_c('v-col', {
          staticClass: "d-flex justify-center align-center",
          attrs: {
            "cols": "12"
          }
        }, [_c('v-avatar', {
          staticClass: "mt-4",
          attrs: {
            "color": _vm.color,
            "size": "80"
          }
        }, [_c('v-avatar', {
          attrs: {
            "dark": "",
            "x-large": ""
          }
        }, [_c('img', {
          attrs: {
            "src": _vm.icon
          }
        })])], 1)], 1)], 1), _c('v-row', [_c('v-col', {
          attrs: {
            "cols": "12"
          }
        }, [_c('h1', {
          class: ['headline text-h4 font-weight-bold text-center']
        }, [_vm._v(" " + _vm._s(_vm.$t("report.home.mobile.title")) + " ")]), _c('div', {
          staticClass: "text-caption ma-4 text-center"
        }, [_c('span', {
          staticClass: "mr-1"
        }, [_vm._v(" " + _vm._s(_vm.partner.companyName) + " ")]), _c('span', [_vm._v(" - ")]), _vm.partner.address ? _c('span', {
          staticClass: "ml-1"
        }, [_vm._v(" " + _vm._s(_vm.partner.address.street) + ", " + _vm._s(_vm.partner.address.zip) + " " + _vm._s(_vm.partner.address.city) + " ")]) : _vm._e()])])], 1), _c('v-card-text', [_c('v-row', {
          staticClass: "d-flex flex-column",
          staticStyle: {
            "min-height": "290px"
          },
          attrs: {
            "align": "center",
            "justify": "center"
          }
        }, [_c('v-list', {
          staticClass: "mobile-report-list"
        }, _vm._l(_vm.items, function (item) {
          return _c('v-list-item', {
            key: item.text
          }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v(" " + _vm._s(item.icon) + " ")])], 1), _c('v-list-item-content', {
            staticClass: "text-left"
          }, [_c('v-list-item-title', {
            staticClass: "list-item-title-wrap"
          }, [_vm._v(_vm._s(_vm.$t(item.text)))])], 1)], 1);
        }), 1)], 1)], 1), _c('v-card-actions', {
          staticClass: "flex-column"
        }, [_c('v-btn', {
          staticClass: "ma-1",
          attrs: {
            "large": "",
            "block": "",
            "color": _vm.color,
            "dark": "",
            "elevation": "0"
          },
          on: {
            "click": _vm.start
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("report.home.mobile.btn")) + " ")]), _vm.showLoginButton ? _c('v-btn', {
          staticClass: "ma-1",
          attrs: {
            "large": "",
            "block": "",
            "color": _vm.color,
            "outlined": "",
            "elevation": "0"
          },
          on: {
            "click": _vm.goToLogin
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("report.home.login")) + " ")]) : _vm._e(), _c('v-bottom-sheet', {
          attrs: {
            "inset": "",
            "max-width": "500px",
            "scrollable": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref) {
              var on = _ref.on,
                  attrs = _ref.attrs;
              return [_c('v-btn', _vm._g(_vm._b({
                staticClass: "ma-1",
                attrs: {
                  "block": "",
                  "color": _vm.color,
                  "large": "",
                  "dark": "",
                  "text": "",
                  "elevation": "0"
                }
              }, 'v-btn', attrs, false), on), [_vm._v(" " + _vm._s(_vm.$t("navCategory.help")) + " ")])];
            }
          }]),
          model: {
            value: _vm.dialog,
            callback: function callback($$v) {
              _vm.dialog = $$v;
            },
            expression: "dialog"
          }
        }, [_c('instruction-card', {
          attrs: {
            "instructionTitle": _vm.instruction.title,
            "instructionText": _vm.instruction.text,
            "instructionImageSrcs": _vm.instruction.imageSrc,
            "instructionVideoSrc": _vm.instruction.videoSrc
          },
          on: {
            "clicked": function clicked($event) {
              _vm.dialog = false;
            }
          }
        })], 1)], 1)], 1), _c('query-params-list')];
      },
      proxy: true
    }])
  });

}
var staticRenderFns = []

export { render, staticRenderFns }